var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('enum-picker',{attrs:{"label":_vm.label,"enum":_vm.takipDurumu,"disabled":_vm.disabled,"clearable":_vm.clearable,"labels":_vm.takipDurumuLabel,"default-first":_vm.isDefaultFirst},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }